import {
  ThreeStars,
  ShoppingBag,
  Controller,
  GraduationHat,
  RedCross,
  IndustrialPlant,
} from './icons';

export const typeFilters = {
  'tien-ich': [
    {
      id: 'kcn',
      icon: ThreeStars,
      label: 'KCN / CCN',
    },
    { id: 'truong-hoc', icon: GraduationHat, label: 'Trường học' },
    { id: 'benh-vien', icon: RedCross, label: 'Bệnh viện' },
    {
      id: 'mall',
      icon: ShoppingBag,
      label: 'Siêu thị / TTTM',
    },
    { id: 'ben-xe', icon: Controller, label: 'Bến xe' },
    { id: 'airport', icon: IndustrialPlant, label: 'Sân bay' },
  ],
  'giao-thong': [
    {
      id: 'truc-duong-chinh',
      icon: ThreeStars,
      label: 'Trục đường chính',
    },
    {
      id: 'truc-duong-phu',
      icon: ThreeStars,
      label: 'Trục đường đô thị',
    },
    { id: 'duong-mau-trang', icon: ThreeStars, label: 'Trục đường phụ' },
    { id: 'duong-song', icon: ThreeStars, label: 'Đường sông' },
  ],
};

export const types = [
  {
    id: 'tien-ich',
    label: 'Tất cả tiện ích',
    labelShort: 'Tiện ích',
  },
  {
    id: 'giao-thong',
    label: 'Tất cả giao thông',
    labelShort: 'Giao thông',
  },
];
